<script setup lang="ts">
import type { Schemas } from "#shopware";

const { product } = defineProps<{
	product: Schemas["Product"];
}>();

const { data, status } = await useLazyAsyncData(`review:stats:${product.id}`, () =>
	useShopwareProductReviewStats(product)
);
</script>
<template>
	<span class="font-medium" v-if="status === 'success'">{{ data?.totalCount }} beoordelingen</span>
</template>
